import { AI_CAPABILITY_PROMPTS } from './onboarding'

export const AI_INTRO_SEEN_KEY = 'comforthub.aiIntroSeen'

export const AI_INTRO_TITLE = 'Meet your AI assistant'

export const AI_INTRO_BODY =
  'ComfortHub AI can walk you through go-live — creating a store, catalog, inventory, offerings, payments, and inviting workers or managers. It explains steps, drafts invites, and proposes changes that always need your Confirm before anything is written.'

export const AI_INTRO_MEET_PROMPT =
  'Introduce yourself as the ComfortHub backoffice AI assistant. Briefly explain how you help merchants go live (store, catalog, inventory, offerings, payments, team), that writes need Confirm, and ask what I should finish next.'

export const AI_INTRO_CAPABILITY_PROMPT =
  AI_CAPABILITY_PROMPTS.whatCanYouDo

export function hasSeenAiIntro(): boolean {
  if (typeof window === 'undefined') return true
  try {
    return localStorage.getItem(AI_INTRO_SEEN_KEY) === 'true'
  } catch {
    return false
  }
}

export function markAiIntroSeen(): void {
  if (typeof window === 'undefined') return
  try {
    localStorage.setItem(AI_INTRO_SEEN_KEY, 'true')
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearAiIntroSeen(): void {
  if (typeof window === 'undefined') return
  try {
    localStorage.removeItem(AI_INTRO_SEEN_KEY)
  } catch {
    /* ignore */
  }
}
